import React from 'react';

interface LoadingStateProps {
  text?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ text = 'Загрузка...' }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '300px',
      padding: '40px 20px',
    }}>
      {/* Спиннер — вращающееся кольцо */}
      <div style={{
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        border: '3px solid rgba(212, 175, 55, 0.15)',
        borderTopColor: '#d4af37',
        animation: 'spin 1s linear infinite',
        marginBottom: '24px',
        boxShadow: '0 0 20px rgba(212, 175, 55, 0.2)',
      }} />

      {/* Текст */}
      <p style={{
        color: '#d4af37',
        fontSize: '16px',
        fontFamily: 'var(--font-sans)',
        letterSpacing: '0.5px',
        opacity: 0.9,
        animation: 'pulse 2s ease-in-out infinite',
      }}>
        {text}
      </p>

      {/* Inline keyframes */}
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default LoadingState;
